import { provideTranslocoScope } from '@jsverse/transloco';
import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ListPageColumnComponent } from 'design-system';
import { AddToCartDialogResult, AddToCartPurchaseHistoryDialog, CartService } from 'products';

@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-select-product-button',
  imports: [MatButtonModule],
  templateUrl: './select-product-button.html',
  styleUrl: './select-product-button.scss',
})
export class SelectProductButton extends ListPageColumnComponent implements OnInit {
  private dialog = inject(MatDialog);
  private cartService = inject(CartService);

  productId: string = '';

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.productId = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  addProduct(event: MouseEvent) {
    event.stopPropagation();

    // Con l'ultima vendita e lo storico; AddToCartDialog per il dialog senza
    this.dialog.open(AddToCartPurchaseHistoryDialog, {
      width: '500px',
      minHeight: '300px',
      data: {
        ultimoAcquisto: this.itemData['ultimoAcquisto'],
        idProdotto: this.productId,
        nomeProdotto: this.itemData['nomeProdotto'],
        sku: this.itemData['sku'],
        nomeImballo: this.itemData['nomeImballo'],
        unitaFatturabile: this.itemData['unitaFatturabile'],
        prezzo: this.itemData['prezzo'],
        unitaMisura: this.itemData['unitaMisura'],
        prezzoMinimo: this.cartService.minimumPrice(this.productId, this.itemData['prezzoMinimoRuolo']),      },
    }).afterClosed().subscribe((result?: AddToCartDialogResult) => {
      if (result) {
        this.cartService.updateProduct(this.productId, result.quantity, result.price)
          .subscribe({
            error: error => {
              console.error('Errore durante l\'aggiunta al carrello', error);
            },
          });
      }
    });
  }
}
